
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/passwordReset",
      function () {
        return require("private-next-pages/passwordReset.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/passwordReset"])
      });
    }
  